import React, { Fragment, useState } from 'react';

import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
  Alert,
  Tooltip
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEquals, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import ButtonIcon from '../../common/ButtonIcon';
import Switch from 'react-switch';

import DisclaimerModal from '../../common/DisclaimerModal';
import ComponentFilter from './ComponentFilter';
import CategoryFilter from './CategoryFilter';
// Managed product components
import PropTypes from 'prop-types';
import VendorMultiSelect from './VendorMultiSelect';
import BZAPIService from '../../../services/BZAPIService';
import { toast } from 'react-toastify';

export default function ProductPriority({
  vendorId,
  vendorLabel,
  vendorPriorityOptions,
  vendorStatusOptions = [],
  vendorSupportStatusOptions = [],
  vendorResolutionOptions = [],
  vendorBugCategoryOptions = [],
  vendorBugTypeOptions = [],
  vendorBugTypes = [],
  vendorBugCategories = [],
  setVendorBugTypes,
  setVendorBugCategories,
  // fortinetBugCategories,
  // setFortinetBugCategories,
  setVendorResolutions = [],
  setVendorStatuses,
  setVendorSupportStatus,
  vendorStatuses = [],
  vendorSupportStatus = [],
  setVendorProductBugCategories,
  vendorProductBugCategories = [],
  vendorProductBugCategoryOptions,
  vendorResolutions = [],
  isSubmitted,
  priorityMaps,
  setPriorityMaps,
  snPriorityOptions,
  title,
  keywords = [],
  setKeywords,
  includedComponents = [],
  setIncludedComponents,
  excludedComponents,
  setExcludedComponents,
  searchFields,
  setSearchFields,
  vendorBugServiceOptions,
  setVendorBugServices,
  vendorBugServices,
  // vendorEventLevelOptions,
  // vendorEventLevels,
  // setVendorEventLevels,
  loader,
  setLoader,
  setQuery,
  query,
  offset,
  limit,
  // supportCasesCount,
  // setCases,
  isCve,
  setIsCve,
  vendorImpactedRegions,
  setVendorImpactedRegions,
  vendorImpactedRegionOptions,
  requireImpactedRegions = true,
  vendorComplianceStatus,
  setVendorComplianceStatus,
  vendorComplianceStatusOptions,
  vendorRiskCategoryOptions,
  vendorRiskCategories,
  setVendorRiskCategories,
  vendorMitigationTypes,
  setVendorMitigationTypes,
  vendorMitigationTypeOptions,
  enableChatGptPriority,
  setEnableChatGptPriority,
  msSqlAgree,
  setMsSqlAgree
}) {
  // debug
  const [keyword, setKeyword] = useState('');
  const [kwError, setKwError] = useState('');
  const [isOpenTooltip, setIsOpenTooltip] = useState('');
  const [isDisclaimerOpen, setIsDisclaimerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const selectStyles = {
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: isFocused ? 'white' : isSelected ? 'white' : 'black'
      };
    }
  };

  const toggleTooltip = (e, id) => {
    const label = id;
    setIsOpenTooltip(e.type === 'mouseover' ? label : '');
  };

  // Generic function to handle react-select single/multi-selects
  function handleSelectChange(e, setHook) {
    const selected = e || [];
    if (Array.isArray(selected)) setHook(selected.map(el => el));
    else setHook(selected);
  }

  // Priority
  const blankPriority = { vendorPriority: null, snPriority: null };
  const addPriority = () => {
    setPriorityMaps([...priorityMaps, { ...blankPriority }]);
  };
  const removePriority = idx => {
    priorityMaps.splice(idx, 1);
    setPriorityMaps([...priorityMaps]);
  };
  const handleCatChange = (e, idx, field) => {
    const selectedOption = e;
    const updatedPriorities = [...priorityMaps];
    updatedPriorities[idx][field] = selectedOption;
    setPriorityMaps(updatedPriorities);
  };

  const addKeyword = () => {
    const k = { value: keyword, label: keyword };
    const duplicate = keywords.filter(kw => kw.label === k.label).length ? true : false;
    if (!duplicate && k.value.length > 0) {
      setKeywords([...keywords, k]);
      setKeyword('');
      setKwError('');
      console.log('keywords', keywords);
    }
    if (duplicate) {
      setKwError('Keyword already in the excluded list.');
    }
  };
  const removeKeyword = e => {
    setKeywords(keywords.filter(k => k.value !== e.target.id));
  };
  const handleKeywordChange = e => {
    const k = e.target.value;
    setKeyword(k);
  };

  function handleToggleSearch(index, enabled) {
    searchFields[index].enabled = enabled;

    setSearchFields([...searchFields]);
  }

  // function to post to reusable API endpoint for disclaimer agreements
  const disclaimerAgree = async e => {
    setIsLoading(true);
    const settingId = 'msftsql';
    const data = {
      type: 'vendor',
      agreementTitle: 'msftSqlAiDisclaimer',
      agreementSigned: e !== undefined ? e : !msSqlAgree
    };
    try {
      // eslint-disable-next-line
      const res = await BZAPIService.postAgreement(settingId, data);
      setIsLoading(false);
      setIsDisclaimerOpen(false);
      setMsSqlAgree(e !== undefined ? e : !msSqlAgree);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
      toast.error('Please try again');
    }
  };

  function handleDisagree() {
    setIsDisclaimerOpen(false);
    setEnableChatGptPriority(false);
  }

  const handleChatGptToggle = e => {
    setEnableChatGptPriority(e);
    if (e === false) disclaimerAgree(e);
    // clear priorities if already set
    setPriorityMaps([]);
    // Add if statement to handle already agreed scenario
    if (e === true) setIsDisclaimerOpen(true);
  };

  return (
    <Card bg={''} text={'dark'} style={{}} className="mb-4">
      <CardBody>
        <Row form>
          {isCve !== undefined ? (
            <Col lg="5" className="mb-4">
              <div>
                <CardTitle>Filter CVE Bugs</CardTitle>
                <CardText>Choose whether or not to include CVE bugs</CardText>
                <div className="">
                  <Switch
                    id={'cve-toggle-switch'}
                    onChange={e => setIsCve(isCve !== undefined ? !isCve : undefined)}
                    checked={isCve}
                    uncheckedIcon={false}
                    onColor="#617E71"
                    className=""
                    height={14}
                    width={28}
                  />
                  <Label className="ml-2">If enabled, CVE bugs will be excluded</Label>
                </div>
              </div>
            </Col>
          ) : (
            ''
          )}

          {vendorStatusOptions?.length && !vendorStatusOptions[0]?.hasOwnProperty('variables') ? (
            <>
              <Col lg="5" className={`${isCve !== undefined ? 'offset-lg-1' : ''} "mb-4"`}>
                <CardTitle data-testid={'bug-statuses-title'}>Select Bug Statuses to Monitor</CardTitle>
                <CardText>Select multiple entries if necessary</CardText>
                <VendorMultiSelect
                  options={vendorStatusOptions}
                  setHook={setVendorStatuses}
                  categories={vendorStatuses}
                  handleSelectChange={handleSelectChange}
                  isSubmitted={isSubmitted}
                  feedback={'a status'}
                  name={'Bug Statuses'}
                  required={true}
                />
              </Col>
            </>
          ) : (
            ''
          )}
          {/* {!!vendorEventLevels?.length || vendorEventLevelOptions?.length ? (
            <Col lg="5" className={`${vendorStatusOptions?.length && isCve === undefined ? 'offset-lg-1' : ''} "mb-4"`}>
              <CardTitle data-testid={'events-levels-title'}>Select Event Levels to Monitor</CardTitle>
              <CardText>Select multiple entries if necessary</CardText>
              <VendorMultiSelect
                options={vendorEventLevelOptions}
                setHook={setVendorEventLevels}
                categories={vendorEventLevels}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a level'}
                name={'Event Levels'}
                required={true}
              />
            </Col>
          ) : (
            ''
          )} */}
          {setVendorSupportStatus && vendorSupportStatusOptions?.length ? (
            <>
              <Col lg="5" className={`mb-4`}>
                <CardTitle data-testid={'bug-statuses-title'}>Select Vendor Support Statuses to Monitor</CardTitle>
                <CardText>Select multiple entries if necessary</CardText>
                <VendorMultiSelect
                  options={vendorSupportStatusOptions}
                  setHook={setVendorSupportStatus}
                  categories={vendorSupportStatus}
                  handleSelectChange={handleSelectChange}
                  isSubmitted={isSubmitted}
                  feedback={'a support status'}
                  name={'Bug Support Statuses'}
                  required={true}
                />
              </Col>
            </>
          ) : (
            ''
          )}

          {!!vendorImpactedRegions?.length || vendorImpactedRegionOptions?.length ? (
            <Col lg="5" className="">
              <CardTitle>Select Impacted Regions to Monitor</CardTitle>
              <CardText>Select multiple entries if necessary</CardText>
              <VendorMultiSelect
                options={vendorImpactedRegionOptions}
                setHook={setVendorImpactedRegions}
                categories={vendorImpactedRegions}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a region'}
                name={'Impacted Regions'}
                required={requireImpactedRegions}
              />
            </Col>
          ) : (
            ''
          )}

          {!!vendorRiskCategories?.length || vendorRiskCategoryOptions?.length ? (
            <Col
              lg="5"
              className={`${
                vendorImpactedRegionOptions?.length || vendorStatusOptions?.length || isCve !== undefined
                  ? 'offset-lg-1'
                  : ''
              }`}
            >
              <CardTitle>Select Risk Categories to Monitor</CardTitle>
              <CardText>Select multiple entries if necessary</CardText>
              <VendorMultiSelect
                options={vendorRiskCategoryOptions}
                setHook={setVendorRiskCategories}
                categories={vendorRiskCategories}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a risk'}
                name={'Risk Categories'}
                required={true}
              />
            </Col>
          ) : (
            ''
          )}
          {!!vendorMitigationTypes?.length || vendorMitigationTypeOptions?.length ? (
            <Col lg="5">
              <CardTitle>Select Mitigation Types to Monitor</CardTitle>
              <CardText>Select multiple entries if necessary</CardText>
              <VendorMultiSelect
                options={vendorMitigationTypeOptions}
                setHook={setVendorMitigationTypes}
                categories={vendorMitigationTypes}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a mitigation type'}
                name={'Mitigation Types'}
                required={false}
              />
            </Col>
          ) : (
            ''
          )}
          {/* {vendorId === 'cisco' ? (
            <Col lg="5" className="offset-lg-1">
              <div>
                <CardTitle data-testid={'support-cases-title'}>Minimum Support Cases Count</CardTitle>
                <CardText>Select the minimum support cases a defect should have to be included</CardText>
                <div className="">
                  <Switch
                    id={'support-cases-switch'}
                    onChange={e => handleSwitchToggle(e)}
                    checked={isCasesOn}
                    uncheckedIcon={false}
                    onColor="#617E71"
                    className=""
                    height={14}
                    width={28}
                    data-testid={'support-cases-switch'}
                  />
                </div>

                <Input
                  type="number"
                  className="w-50"
                  value={parseFloat(supportCasesCount).toFixed(0)}
                  onChange={e => changeCases(e)}
                  disabled={!isCasesOn}
                  min={0}
                  step={1}
                  data-testid={'support-cases-input'}
                />
              </div>
            </Col>
          ) : (
            ''
          )} */}
        </Row>
        {!!includedComponents.length ? (
          <ComponentFilter
            vendorId={vendorId}
            vendorLabel={vendorLabel}
            loader={loader}
            setLoader={setLoader}
            setQuery={setQuery}
            query={query}
            offset={offset}
            limit={limit}
            includedComponents={includedComponents}
            setIncludedComponents={setIncludedComponents}
            excludedComponents={excludedComponents}
            setExcludedComponents={setExcludedComponents}
          />
        ) : (
          ''
        )}
        {!!vendorProductBugCategories?.length || vendorProductBugCategoryOptions?.length ? (
          <>
            <CategoryFilter
              vendorId={vendorId}
              vendorLabel={vendorLabel}
              loader={loader}
              setLoader={setLoader}
              vendorProductBugCategoryOptions={vendorProductBugCategoryOptions}
              vendorProductBugCategories={vendorProductBugCategories}
              setVendorProductBugCategories={setVendorProductBugCategories}
              excludedComponents={excludedComponents}
              setExcludedComponents={setExcludedComponents}
            />
            <br />
          </>
        ) : (
          ''
        )}
        {!!vendorBugServiceOptions?.length || vendorBugServices?.length ? (
          <>
            <CategoryFilter
              vendorId={vendorId}
              vendorLabel={vendorLabel}
              loader={loader}
              setLoader={setLoader}
              vendorBugServiceOptions={vendorBugServiceOptions}
              vendorBugServices={vendorBugServices}
              setVendorBugServices={setVendorBugServices}
              excludedComponents={excludedComponents}
              setExcludedComponents={setExcludedComponents}
            />
            <br />
          </>
        ) : (
          ''
        )}
        {/* Add conditional based on search_fields to display this component */}
        <div className="mb-4">
          <CardTitle data-testid={'kw-exclude-title'}>Keywords to Exclude</CardTitle>
          <CardText>Add multiple entries if necessary</CardText>
          <p className="text-danger">{kwError}</p>
          <Row form>
            <Col md={5}>
              <Input
                type="text"
                name="keyword"
                id="keyword"
                placeholder="Add keyword..."
                value={keyword}
                onChange={e => handleKeywordChange(e)}
                onKeyDown={e => (e.key === 'Enter' ? addKeyword() : null)}
                data-testid={'kw-input'}
              />
              <ButtonIcon
                onClick={addKeyword}
                color="falcon-default"
                size="sm"
                icon="plus"
                iconClassName="fs--2"
                className="mt-2"
                data-testid={'kw-add-btn'}
              >
                Add
              </ButtonIcon>

              <div className="mt-3">
                {searchFields?.length ? (
                  <>
                    <CardText>Choose fields to be included in search for excluded keywords</CardText>
                    {searchFields.map(({ value, label, enabled }, index) => (
                      <FormGroup check key={value}>
                        <Input
                          type="checkbox"
                          checked={enabled}
                          onChange={() => handleToggleSearch(index, enabled ? 0 : 1)}
                          data-testid={label + '-checkbox'}
                        />
                        <Label check data-testid={label + '-label'}>
                          {' '}
                          {label}
                        </Label>
                      </FormGroup>
                    ))}
                  </>
                ) : (
                  ''
                )}
              </div>
            </Col>
            <Col className="border rounded p-2 ml-3 mh-10 bg-white">
              <Row className="ml-1" data-testid={'kwds'}>
                {keywords &&
                  keywords.map(keyword => {
                    return (
                      <div key={keyword.value} className="btn-toolbar my-1 mr-2" role="toolbar">
                        <div className="btn-group" role="group" aria-label={keyword.label}>
                          <div className="btn kw-exclude-btn btn-sm">{keyword.label}</div>
                          <div
                            className="btn kw-exclude-btn btn-sm fw-bold"
                            id={keyword.label}
                            onClick={e => removeKeyword(e)}
                          >
                            x
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </Row>
            </Col>
          </Row>
        </div>
        <Row>
          {!!vendorBugTypeOptions?.length && (
            <Col lg="5">
              <CardTitle data-testid={'bug-types-title'}>Select Bug Types to Monitor</CardTitle>
              <CardText>Select multiple entries if necessary</CardText>
              <VendorMultiSelect
                options={vendorBugTypeOptions}
                setHook={setVendorBugTypes}
                categories={vendorBugTypes}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a type'}
                name={'Bug Types'}
                required={true}
              />
            </Col>
          )}
          {!!vendorComplianceStatus?.length || vendorComplianceStatusOptions?.length ? (
            <Col lg="5">
              <CardTitle>Select Compliance Status</CardTitle>
              <CardText>Select multiple entries if necessary</CardText>
              <VendorMultiSelect
                options={vendorComplianceStatusOptions}
                setHook={setVendorComplianceStatus}
                categories={vendorComplianceStatus}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a compliance status'}
                name={'Compliance Status'}
                required={true}
              />
            </Col>
          ) : (
            ''
          )}
          {!!vendorBugCategoryOptions?.length && vendorId !== 'fortinet' && (
            <Col lg="5" className={`${vendorBugTypeOptions.length && 'offset-lg-1'} ''`}>
              <CardTitle data-testid={'bug-categories-title'}>Select Bug Categories to Monitor</CardTitle>
              <CardText>Select multiple entries if necessary</CardText>
              <VendorMultiSelect
                options={vendorBugCategoryOptions}
                setHook={setVendorBugCategories}
                categories={vendorBugCategories}
                handleSelectChange={handleSelectChange}
                isSubmitted={isSubmitted}
                feedback={'a category'}
                name={'Bug Categories'}
                required={true}
              />
            </Col>
          )}
        </Row>
        {!!vendorResolutionOptions?.length && (
          <>
            <CardTitle data-testid={'bug-resolutions-title'}>Select Bug Resolutions to Monitor</CardTitle>
            <CardText>Select multiple entries if necessary</CardText>
            <Row form>
              <Col lg="5">
                <VendorMultiSelect
                  options={vendorResolutionOptions}
                  setHook={setVendorResolutions}
                  categories={vendorResolutions}
                  handleSelectChange={handleSelectChange}
                  isSubmitted={isSubmitted}
                  feedback={'a resolution'}
                  name={'Bug Resolutions'}
                  required={false}
                />
              </Col>
            </Row>
            <br />
          </>
        )}
        <CardTitle data-testid={'priorities-title'}>
          Map Vendor Severity to ServiceNow Priority
          <span style={{ color: '#bd472a' }}>*</span>
        </CardTitle>
        <CardText>Specify which severities and priorities to monitor</CardText>
        {/* ADD IF ENABLE TO REMOVE FROM MANAGED PRODUCTS */}
        {vendorId === 'msftsql' && enableChatGptPriority !== undefined ? (
          <div className="">
            <Switch
              id={'chatGptPriority-toggle-switch'}
              onChange={e => handleChatGptToggle(e)}
              checked={enableChatGptPriority}
              uncheckedIcon={false}
              onColor="#617E71"
              className=""
              height={14}
              width={28}
            />
            <Label className="mx-2">Use AI Generated Bug Severities</Label>
            <svg id="ai-severities" xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
              <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
            </svg>
            <Tooltip
              placement="top"
              isOpen={isOpenTooltip === 'ai-severities'}
              target={'ai-severities'}
              autohide={true}
              toggle={e => toggleTooltip(e, 'ai-severities')}
            >
              BugZero enhanced input from field experts with AI to offer this exclusive filter. These severities are not
              provided by the vendor.
            </Tooltip>
            <DisclaimerModal
              showAlert={isDisclaimerOpen}
              setShowAlert={setIsDisclaimerOpen}
              title={'Disclaimer Agreement'}
              text={
                'I understand this feature is based on Bugzero proprietary AI-generated information and is not based on information directly from the vendor.'
              }
              action={disclaimerAgree}
              cancel={handleDisagree}
              isLoading={isLoading}
            />
          </div>
        ) : (
          <></>
        )}
        {!!priorityMaps?.length && (
          <Fragment>
            <Row form>
              <Col lg={5}>
                <FormGroup>
                  <Label>Vendor Severity</Label>
                </FormGroup>
              </Col>
              <Col lg={1}>
                <FormGroup style={{ textAlign: 'center', marginTop: '38px' }} />
              </Col>
              <Col lg={5}>
                <FormGroup>
                  <Label>ServiceNow Impact / Urgency / Priority</Label>
                </FormGroup>
              </Col>
            </Row>
          </Fragment>
        )}
        {/* Priority */}
        {priorityMaps?.map((val, idx) => {
          const vendorPriority = `vendor-${idx}`;
          const snPriority = `snPriority-${idx}`;
          return (
            <Fragment key={`priority-${idx}`}>
              <Row form>
                <Col md={5}>
                  <FormGroup>
                    <div data-testid={'severity-select'}>
                      <Select
                        id={vendorPriority}
                        name={vendorPriority}
                        value={priorityMaps[idx].vendorPriority}
                        onChange={e => handleCatChange(e, idx, 'vendorPriority')}
                        // loadOptions={loadOptions}
                        // Filter options if ai severities are on or off using isCustom bool
                        options={
                          enableChatGptPriority
                            ? vendorPriorityOptions
                                ?.filter(o => {
                                  return o.isCustom;
                                })
                                ?.filter(vendorPriorityOption => {
                                  // Filter out values already set
                                  const result = priorityMaps.filter(e => {
                                    if (!e.vendorPriority) {
                                      return false;
                                    }
                                    return e.vendorPriority.value === vendorPriorityOption.value;
                                  });
                                  return result.length ? false : true;
                                })
                            : vendorPriorityOptions
                                ?.filter(o => {
                                  return !o.isCustom;
                                })
                                ?.filter(vendorPriorityOption => {
                                  // Filter out values already set
                                  const result = priorityMaps.filter(e => {
                                    if (!e.vendorPriority) {
                                      return false;
                                    }
                                    return e.vendorPriority.value === vendorPriorityOption.value;
                                  });
                                  return result.length ? false : true;
                                })
                        }
                        theme={theme => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            // text: 'white',
                            primary25: '#253746',
                            primary: '#253746'
                            // neutral80: 'white'
                          }
                        })}
                        styles={selectStyles}
                        required
                      />
                    </div>
                    <FormFeedback
                      className={!priorityMaps[idx].vendorPriority && isSubmitted ? 'd-block' : ''}
                      type="invalid"
                      data-testid={'severity-feedback'}
                    >
                      Please select a priority.
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col md={1}>
                  <FormGroup style={{ textAlign: 'center', marginTop: '7px' }}>
                    <FontAwesomeIcon icon={faEquals} color={'#253746'} />
                  </FormGroup>
                </Col>
                <Col md={5}>
                  <FormGroup>
                    <div data-testid={'priority-select'}>
                      <Select
                        id={snPriority}
                        name={snPriority}
                        value={priorityMaps[idx].snPriority}
                        onChange={e => handleCatChange(e, idx, 'snPriority')}
                        options={snPriorityOptions}
                        required
                        theme={theme => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            // text: 'white',
                            primary25: '#253746',
                            primary: '#253746'
                            // neutral0: 'white',
                            // neutral80: 'white'
                          }
                        })}
                        styles={selectStyles}
                      />
                    </div>
                    <FormFeedback
                      className={!priorityMaps[idx].snPriority && isSubmitted ? 'd-block' : ''}
                      type="invalid"
                      data-testid={'priority-feedback'}
                    >
                      Please select a priority.
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col md={1}>
                  <FormGroup style={{ textAlign: 'center', marginTop: '7px' }}>
                    <FontAwesomeIcon icon={faMinusCircle} color={'#bd472a'} onClick={() => removePriority(idx)} />
                  </FormGroup>
                </Col>
              </Row>
            </Fragment>
          );
        })}
        <Row form>
          <Col lg="5">
            <FormGroup>
              <FormFeedback className={!priorityMaps?.length && isSubmitted ? 'd-block' : ''} type="invalid">
                <Alert color="danger">Please add a priority.</Alert>
              </FormFeedback>
            </FormGroup>
            <FormGroup>
              <ButtonIcon
                onClick={addPriority}
                color="falcon-default"
                size="sm"
                icon="plus"
                iconClassName="fs--2"
                data-testid={'add-priority-btn'}
              >
                Add priority
              </ButtonIcon>
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

ProductPriority.propTypes = {
  vendorId: PropTypes.string,
  vendorPriorityOptions: PropTypes.array,
  vendorStatusOptions: PropTypes.array,
  vendorSupportStatusOptions: PropTypes.array,
  vendorBugCategoryOptions: PropTypes.array,
  vendorBugTypeOptions: PropTypes.array,
  handleSelectChange: PropTypes.func,
  setVendorStatuses: PropTypes.func,
  setVendorSupportStatus: PropTypes.func,
  setVendorProductBugCategories: PropTypes.func,
  vendorBugTypes: PropTypes.array,
  vendorBugCategories: PropTypes.array,
  fortinetBugCategories: PropTypes.array,
  setFortinetBugCategories: PropTypes.func,
  setVendorBugTypes: PropTypes.func,
  setVendorBugCategories: PropTypes.func,
  vendorResolutionOptions: PropTypes.array,
  setVendorResolutions: PropTypes.func,
  vendorResolutions: PropTypes.array,
  vendorStatuses: PropTypes.array,
  vendorSupportStatus: PropTypes.array,
  vendorProductBugCategories: PropTypes.array,
  isSubmitted: PropTypes.bool,
  priorityMaps: PropTypes.array,
  snPriorityOptions: PropTypes.array,
  setPriorityMaps: PropTypes.func,
  title: PropTypes.string,
  keywords: PropTypes.array,
  setKeywords: PropTypes.func,
  includedComponents: PropTypes.array,
  setIncludedComponents: PropTypes.func,
  excludedComponents: PropTypes.array,
  setExcludedComponents: PropTypes.func,
  searchFields: PropTypes.array,
  setSearchFields: PropTypes.func,
  vendorProductBugCategoryOptions: PropTypes.array,
  vendorBugServiceOptions: PropTypes.array,
  setVendorBugServices: PropTypes.func,
  vendorBugServices: PropTypes.array,
  // vendorEventLevelOptions: PropTypes.array,
  // vendorEventLevels: PropTypes.array,
  // setVendorEventLevels: PropTypes.func,
  vendorLabel: PropTypes.string,
  loader: PropTypes.bool,
  setLoader: PropTypes.func,
  setQuery: PropTypes.func,
  query: PropTypes.string,
  offset: PropTypes.string,
  limit: PropTypes.string,
  // supportCasesCount: PropTypes.number,
  // setCases: PropTypes.func,
  isCve: PropTypes.bool,
  setIsCve: PropTypes.func,
  vendorImpactedRegions: PropTypes.array,
  setVendorImpactedRegions: PropTypes.func,
  vendorImpactedRegionOptions: PropTypes.array,
  requireImpactedRegions: PropTypes.bool,
  vendorComplianceStatus: PropTypes.array,
  setVendorComplianceStatus: PropTypes.func,
  vendorComplianceStatusOptions: PropTypes.array,
  setVendorRiskCategories: PropTypes.func,
  vendorRiskCategories: PropTypes.array,
  vendorRiskCategoryOptions: PropTypes.array,
  vendorMitigationTypes: PropTypes.array,
  setVendorMitigationTypes: PropTypes.func,
  vendorMitigationTypeOptions: PropTypes.array,
  enableChatGptPriority: PropTypes.bool,
  setEnableChatGptPriority: PropTypes.func,
  msSqlAgree: PropTypes.bool,
  setMsSqlAgree: PropTypes.func
};
